import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const IOSIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.339 5.87102C15.2652 5.91722 13.5084 6.89222 13.5084 9.05402C13.5912 11.5194 15.7254 12.384 15.762 12.384C15.7254 12.4302 15.4398 13.5618 14.5938 14.748C13.9224 15.7698 13.1772 16.8 12.0456 16.8C10.9692 16.8 10.5828 16.119 9.3408 16.119C8.007 16.119 7.6296 16.8 6.6084 16.8C5.4768 16.8 4.6764 15.7146 3.9684 14.7024C3.0486 13.3776 2.2668 11.2986 2.2392 9.30242C2.2206 8.24462 2.4234 7.20482 2.9382 6.32162C3.6648 5.08862 4.962 4.25162 6.3786 4.22402C7.464 4.18742 8.43 4.96922 9.0924 4.96922C9.7272 4.96922 10.914 4.22402 12.2568 4.22402C12.8364 4.22462 14.382 4.39922 15.339 5.87102ZM9.0006 4.01282C8.8074 3.04682 9.3408 2.08082 9.8376 1.46462C10.4724 0.719423 11.475 0.213623 12.3396 0.213623C12.3948 1.17962 12.045 2.12702 11.4198 2.81702C10.8588 3.56222 9.8928 4.12322 9.0006 4.01282Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default IOSIcon;
